import { render } from "./ComoSeCalcula.vue?vue&type=template&id=e191f4a6&scoped=true"
const script = {}

import "./ComoSeCalcula.vue?vue&type=style&index=0&id=e191f4a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e191f4a6"]])

export default __exports__